import type { FC, ReactNode, SVGProps } from 'react'

/** Instagram mark, drawn inline so it inherits currentColor and needs no icon font. */
export const InstagramGlyph: FC<SVGProps<SVGSVGElement>> = (props): ReactNode => {
    return (
        <svg
            viewBox='0 0 24 24'
            fill='none'
            stroke='currentColor'
            strokeWidth={1.75}
            strokeLinecap='round'
            strokeLinejoin='round'
            aria-hidden='true'
            focusable='false'
            {...props}
        >
            <rect x={2.75} y={2.75} width={18.5} height={18.5} rx={5.25} />
            <circle cx={12} cy={12} r={4} />
            <circle cx={17.4} cy={6.6} r={1.1} fill='currentColor' stroke='none' />
        </svg>
    )
}
